import LegalLayout, { Section } from "@/components/LegalLayout";

export default function Terms() {
  return (
    <LegalLayout
      testId="page-terms"
      title="Terms & Conditions"
      subtitle={`Welcome to Clocked In One ("we," "our," or "us"). These Terms & Conditions govern your use of our website, https://clockedinone.com.`}
      effectiveDate="August 6, 2026"
      showTemplateDisclaimer={false}
    >
      <p className="text-slate-700 text-[15px] leading-relaxed">
        By accessing or using this website, you agree to be bound by these Terms &amp; Conditions. If you do not agree with any part of these terms, please do not use our website.
      </p>

      <Section heading="1. Purpose of the Website">
        <p>This website is provided for informational and marketing purposes. It is intended to showcase the features and capabilities of the Clocked In One workforce management platform and allow prospective customers to contact us or request a demonstration.</p>
      </Section>

      <Section heading="2. Website Use">
        <p>You agree to use this website only for lawful purposes and in a manner that does not interfere with its operation or the use of the website by others.</p>
        <p>You must not:</p>
        <ul className="list-disc pl-5 space-y-1.5">
          <li>Attempt to gain unauthorized access to our systems or servers.</li>
          <li>Use the website to transmit malicious software or harmful code.</li>
          <li>Copy, reproduce, or distribute website content without prior written permission.</li>
          <li>Use the website in any way that violates applicable laws or regulations.</li>
        </ul>
      </Section>

      <Section heading="3. Intellectual Property">
        <p>All content on this website, including text, graphics, logos, images, icons, designs, and other materials, is the property of Clocked In One or its licensors and is protected by applicable intellectual property laws.</p>
        <p>You may view or download website content for personal, non-commercial use only. Any other use requires our prior written consent.</p>
      </Section>

      <Section heading="4. Product Information">
        <p>We strive to ensure that all information on this website is accurate and up to date. However, product features, specifications, pricing, availability, and services may change without prior notice.</p>
        <p>Information provided on this website does not constitute a binding offer or contractual commitment.</p>
      </Section>

      <Section heading="5. Third-Party Links">
        <p>Our website may contain links to third-party websites for your convenience.</p>
        <p>We are not responsible for the content, security, or privacy practices of third-party websites and encourage users to review their respective policies.</p>
      </Section>

      <Section heading="6. Disclaimer">
        <p>The information provided on this website is for general informational purposes only.</p>
        <p>While we make reasonable efforts to keep the information accurate and current, we make no warranties or representations regarding its completeness, reliability, suitability, or availability.</p>
        <p>Your use of the website is at your own risk.</p>
      </Section>

      <Section heading="7. Limitation of Liability">
        <p>To the fullest extent permitted by applicable law, Clocked In One shall not be liable for any direct, indirect, incidental, consequential, or special damages arising from or related to your use of this website.</p>
      </Section>

      <Section heading="8. Privacy">
        <p>Your use of this website is also governed by our <a className="text-[#00A651] font-semibold" href="/privacy">Privacy Policy</a>, which explains how we collect and use information submitted through our contact forms.</p>
      </Section>

      <Section heading="9. Changes to These Terms">
        <p>We reserve the right to modify these Terms &amp; Conditions at any time.</p>
        <p>Any updates will be published on this page with a revised Effective Date. Continued use of the website constitutes acceptance of the updated Terms.</p>
      </Section>

      <Section heading="10. Governing Law">
        <p>These Terms &amp; Conditions shall be governed by and interpreted in accordance with the laws of India.</p>
        <p>Any disputes arising from the use of this website shall be subject to the exclusive jurisdiction of the courts located in Jaipur, Rajasthan, India.</p>
      </Section>

      <Section heading="11. Contact Us">
        <p>If you have any questions regarding these Terms &amp; Conditions, please contact us:</p>
        <div className="mt-2 space-y-1">
          <div><b>Clocked In One</b></div>
          <div>Website: <a className="text-[#00A651] font-semibold" href="https://clockedinone.com" target="_blank" rel="noopener noreferrer">https://clockedinone.com</a></div>
        </div>
      </Section>
    </LegalLayout>
  );
}
